import { useQuery } from '@tanstack/react-query';
import { learnerIntegrationsService } from '../../services/learnerIntegrationsService';

export const learnerCalendarKeys = {
  all: ['me', 'integrations', 'google', 'events'] as const,
  range: (fromIso: string, toIso: string) =>
    [...learnerCalendarKeys.all, fromIso, toIso] as const,
};

interface UseLearnerCalendarEventsArgs {
  from: Date;
  to: Date;
  enabled?: boolean;
}

export function useLearnerCalendarEvents({
  from,
  to,
  enabled = true,
}: UseLearnerCalendarEventsArgs) {
  return useQuery({
    queryKey: learnerCalendarKeys.range(from.toISOString(), to.toISOString()),
    queryFn: () => learnerIntegrationsService.listEvents(from, to),
    staleTime: 60_000,
    enabled,
    select: (envelope) => envelope.data?.events ?? [],
  });
}
